// extracted by mini-css-extract-plugin
module.exports = {"matchStatus":"MatchStatus_matchStatus__1Y8V4","error":"MatchStatus_error__1hyMY","info":"MatchStatus_info__2h_az","match":"MatchStatus_match__2IVtB"};